import React, {useEffect} from "react";
import classes from "../Login.module.scss";
import RoundedButton from "../../Buttons/RoundedButton";
import TagInput from "../../UI/Inputs/TagInput";
import H1 from "../../UI/Titles/H1/h1";
import { useTranslation } from "react-i18next";
import {
  CUSTOM_OCCUPATION,
} from "../../../constants/users_login";
import * as kApi from "../../../constants/api";
import { PROD } from "../../../constants/defaults";

const VerifyCodeForm = ({
  login = {},
  errorMsg = null,
  formSubmit = () => {},
  onChange = () => {},
  signout = () => {},
}) => {
  const { t } = useTranslation();
  const isProd = kApi.GET_PROD_OR_DEV === PROD;

function RdStation() {
  const dataobj = JSON.stringify({
    event_type: "CONVERSION",
    event_family: "CDP",
    payload: {
      conversion_identifier: `Novo cadastro no Afinando`,
      name: login.given_name,
      email: login.username,
      job_title: login[CUSTOM_OCCUPATION],
      state: "Usuário",
      client_tracking_id: "lead tracking client_id",
      traffic_source: "probrain.afinandoocerebro.com.br",
      traffic_medium: "cpc",
      traffic_campaign: "easter-50-off",
      traffic_value: "easter eggs",
      available_for_mailing: true,
      legal_bases: [
        {
          category: "communications",
          type: "consent",
          status: "granted",
        },
      ],
      cf_my_custom_field: "custom field value",
    },
  });
  if (isProd) {
    fetch(kApi.API_RD_STATION, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: dataobj,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        console.log(JSON.stringify(data));
      });
  }
}
useEffect(() => {
  RdStation();
}, []);

function pixel() {
  const dataobj = JSON.stringify({
    data: [
      {
        event_name: "Lead",
        event_time: Math.floor(+new Date() / 1000),
        action_source: "website",
        event_source_url: window.location.href,
        user_data: {
          em: [
            "7b17fb0bd173f625b58636fb796407c22b3d16fc78302d79f0fd30c2fc2fc068",
          ],
          ph: [null],
          client_user_agent: null,
          client_ip_address: null,
        },
        custom_data: {
          currency: "USD",
          value: 39.9,
        },
      },
    ],
  });
  if (isProd) {
    fetch(kApi.API_PIXEL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: dataobj,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        console.log(JSON.stringify(data));
      });
  }
}
useEffect(() => {
  pixel();
  console.log(`You changed the page to: ${window.location.href}`);
}, []);

  return (
    <>
      <form className={classes.Form} onSubmit={(event) => formSubmit(event)}>
        <H1 className={classes.Title}>{t("global.verify_code")}</H1>
        {errorMsg && <div className={classes.ErrorMsg}>{t(errorMsg)}</div>}
        <TagInput
          type="text"
          name="verify_codigo"
          className={classes.Input}
          placeholder={t("global.eg") + " 00000..."}
          value={login.verify_codigo}
          onChange={onChange}
          required
        />
        <p className={classes.TextInfo}>{t("global.check_your_email")}</p>
        <RoundedButton
          type="submit"
          text={t("global.confirm")}
          className={classes.BtnEnter}
        />
        <button
          tabIndex="0"
          className={classes.TextInfo + " link"}
          onClick={signout}
        >
          {t("global.signout")}?
        </button>
      </form>
    </>
  );
};

export default VerifyCodeForm;
